import Axios from 'axios'
import {membershipSettingUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_membership_settings (context) {
    Axios.get(membershipSettingUrls.getAllMembershipSettings).then(function (response) {
      context.commit('GET_ALL_MEMBERSHIP_SETTINGS', response.data)
    })
  },
  get_all_green_membership_settings (context) {
    Axios.get(membershipSettingUrls.getAllGreenMembershipSettings).then(function (response) {
      context.commit('GET_GREEN_MEMBERSHIP_SETTING', response.data)
    })
  },
  get_membership_settings (context, publicId) {
    Axios.get(membershipSettingUrls.getMembershipSettings + publicId).then(function (response) {
      context.commit('GET_MEMBERSHIP_SETTINGS', response.data)
    })
  },
  get_deleted_membership_settings (context) {
    Axios.get(membershipSettingUrls.getDeletedMembershipSetting).then(function (response) {
      context.commit('GET_DELETED_MEMBERSHIP_SETTINGS', response.data)
    })
  },
  get_membership_setting (context, publicId) {
    Axios.get(membershipSettingUrls.getMembershipSetting + publicId).then(function (response) {
      context.commit('GET_MEMBERSHIP_SETTING', response.data)
    })
  },
  post_membership_setting (context, data) {
    Axios.post(membershipSettingUrls.postMembershipSetting, data).then(function () {
      context.dispatch('get_all_membership_settings')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_membership_setting (context, data) {
    Axios.post(membershipSettingUrls.editMembershipSetting, data).then(function () {
      context.dispatch('get_all_membership_settings')
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
    })
  },
  delete_membership_setting (context, data) {
    Axios.patch(membershipSettingUrls.deleteMembershipSetting, data).then(function () {
      context.dispatch('get_all_membership_settings')
    })
  },
  restoreMembershipSetting (context, publicId) {
    Axios.get(membershipSettingUrls.restoreMembershipSetting + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_MEMBERSHIP_SETTINGS', response.data)
      router.push({
        name: 'Module.MembershipSettings'
      })
    })
  }
}
